import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  CheckCircle2,
  GraduationCap,
  ArrowRight,
  Home,
} from "lucide-react";

export default function ApplicationSuccess() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-sky-100 via-white to-teal-100 px-4 py-12">
      <motion.div
        initial={{ opacity: 0, y: 35, scale: 0.96 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-xl overflow-hidden rounded-3xl bg-white shadow-2xl"
      >
        <div className="relative overflow-hidden bg-gradient-to-r from-[#016C94] to-[#42B8D9] px-6 py-10 text-center text-white">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: "spring" }}
            className="mx-auto mb-4 flex h-24 w-24 items-center justify-center rounded-full bg-white/20 ring-8 ring-white/10"
          >
            <CheckCircle2 size={58} strokeWidth={1.8} />
          </motion.div>

          <h1 className="text-3xl font-extrabold sm:text-4xl">
            Application Submitted!
          </h1>

          <p className="mt-3 text-sm text-white/90 sm:text-base">
            Your application has been successfully submitted.
          </p>
        </div>

        <div className="px-6 py-9 text-center sm:px-10">
          <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-sky-50 text-[#016C94]">
            <GraduationCap size={32} />
          </div>

          <h2 className="text-2xl font-bold text-gray-800">
            Thank You for Applying!
          </h2>

          <p className="mx-auto mt-4 max-w-md leading-7 text-gray-600">
            Thank you for choosing our university. Your application
            information has been received. Please keep your contact
            information available for future communication regarding
            your admission.
          </p>

          <div className="mt-7 rounded-xl border border-green-200 bg-green-50 p-4 text-left">
            <div className="flex items-start gap-3">
              <CheckCircle2
                className="mt-0.5 shrink-0 text-green-600"
                size={22}
              />
              <div>
                <p className="font-semibold text-green-800">
                  Submission successful
                </p>
                <p className="mt-1 text-sm text-green-700">
                  Your application was accepted by the submission API.
                  Keep any application reference provided by the university.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#016C94] px-6 py-3 font-semibold text-white transition hover:bg-[#014864]"
            >
              <Home size={18} />
              Back to Home
            </Link>

            <Link
              to="/apply-online"
              className="inline-flex items-center justify-center gap-2 rounded-xl border border-gray-300 px-6 py-3 font-semibold text-gray-700 transition hover:bg-gray-50"
            >
              Apply Again
              <ArrowRight size={18} />
            </Link>
          </div>

          <p className="mt-8 text-xs text-gray-400">
            If you need assistance, please contact the admission office.
          </p>
        </div>
      </motion.div>
    </div>
  );
}
